import SyncPlanToSoView from "./SyncPlanToSoView";
import SyncPlanToTransferView from "./SyncPlanToTransferView";

const SyncPlanToOdooView = ({ planId, odooObject, didSyncedToOdoo }) => {
  if (odooObject.objectType === "TRANSFER")
    return (
      <SyncPlanToTransferView
        planId={planId}
        odooObject={odooObject}
        didSyncedToOdoo={didSyncedToOdoo}
      />
    );

  if (odooObject.objectType === "SO")
    return (
      <SyncPlanToSoView
        planId={planId}
        odooObject={odooObject}
        didSyncedToOdoo={didSyncedToOdoo}
      />
    );

  return <div>Unsupported Odoo Object Type</div>;
};

export default SyncPlanToOdooView;
